(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["new-arrivals"] && !Shopify.designMode) return;
  try {
    
    (function () {
      function reinitYotpoWidgets(section) {
        if (!section || !section.querySelector || !section.querySelector('.yotpo-widget-instance')) {
          return;
        }
        if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
          window.yotpoWidgetsContainer.initWidgets();
        }
      }

      document.addEventListener('shopify:section:load', function (event) {
        reinitYotpoWidgets(event.target);
      });
    })();
  
  } catch(e) { console.error(e); }
})();
})();
